// extracted by mini-css-extract-plugin
export default {"custom-dropdown":"InfoProvider_custom-dropdown__HsgpV","item":"InfoProvider_item__GeQI5"};